<template>
    <div class="w-[100vw] h-[100vh] fixed top-0 left-0 z-50 flex justify-center items-center bg-[#0000005a]" >
        <div class="text-[var(--text)] gap-4 p-4 bg-[var(--fundoComponente)] rounded-[10px] flex flex-col popup-content">
            <div class="w-full gap-[2rem] flex justify-between items-center">
                <h3 class="text-[var(--titulo)]">Criar Serviço</h3>
                <div class="flex gap-2 items-center">
                    <AppButton class="text-[var(--text)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
                        emitType="close" @close="close" :width="23" :height="23" />
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <!-- INICIO -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Inicio:</label>
                    <input type="date" v-model="inicioDate"
                        :max="fimDate"
                        class="w-[9rem] text-[10px] p-1 rounded-[5px]"
                        :class="{ 'input-required': !isValidDate(inicioDate) }" />
                    <input v-if="!hideTime" type="time" v-model="inicioTime"
                        class="w-[8.5rem] text-[10px] p-1 rounded-[5px]"
                        :class="{ 'input-required': !isValidTime(inicioTime) }" />
                </div>

                <!-- FIM -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Fim:</label>
                    <input type="date" v-model="fimDate"
                        class="w-[9rem] text-[10px] p-1 rounded-[5px]"
                        :min="inicioDate"
                        :class="{ 'input-required': !isValidDate(fimDate) }" />
                    <input v-if="!hideTime" type="time" v-model="fimTime"
                        class="w-[8.5rem] text-[10px] p-1 rounded-[5px]"
                        :class="{ 'input-required': !isValidTime(fimTime) }" />
                </div>

                <!-- TÉCNICO (only if hideTecnico is false) -->
                <div v-if="!hideTecnico" class="flex gap-2">
                    <label class="min-w-[7.5rem]">Técnico:</label>
                    <input disabled type="text" v-model="model.tecnico.nome"
                        placeholder="N/A (Sem o técnico só pode ser criado o serviço)"
                        class="w-[18rem] placeholder-yellow-500 text-[10px] p-1 rounded-[5px]" />
                    <button v-if="!isTecnico" class="fa-regular fa-circle-xmark text-2xl" :style="{ color: 'var(--obrigatorio)' }"
                        @click="remove('tecnico')"></button>
                </div>

                <!-- LOCAL -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Local Instalação:</label>
                    <input disabled type="text" v-model="model.local.nome" placeholder="Local Instalação"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': !model.local.nome }" />
                    <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: 'var(--icon)' }"
                        @click="openDialog('localinstalacao')"></button>
                    <button class="fa-solid fa-circle-plus text-2xl" :style="{ color: 'var(--icon)' }"
                        @click="showCreateLocal_PopUp = true"></button>
                </div>

                <!-- ORDEM DE COMPRA (apenas se localInstalacao.purchaseOrder=true) -->
                <div v-if="requiresPurchaseOrder" class="flex gap-2">
                    <label class="min-w-[7.5rem]">Ordem Compra:</label>
                    <input
                        type="text"
                        v-model="model.ordem_compra"
                        placeholder="Insira a ordem de compra"
                        maxlength="350"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': !ordemCompraValida }"
                    />
                </div>

                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Tipo de Negócio:</label>
                    <input disabled type="text" v-model="model.tpNegocio.nome" placeholder="Tipo de Negócio"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': !model.tpNegocio.nome }" />
                    <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: 'var(--icon)' }"
                        @click="openDialog('tpnegocio')"></button>
                    
                </div>

                <!-- FAMILIA -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Familia:</label>
                    <input disabled type="text" v-model="model.familia.nome" placeholder="Familia"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': !model.familia.nome }" />
                    <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: 'var(--icon)' }"
                        @click="openDialog('familia')"></button>
                </div>

                <!-- SERVIÇO -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Serviço:</label>
                    <input disabled type="text" v-model="model.servico.nome" placeholder="Serviço"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': !model.servico.nome }" />
                    <button class="fa-solid fa-pen-to-square text-2xl"
                        :style="{ color: model.familia.id === 0 || model.local.id === 0 ? 'var(--desativado)' : 'var(--icon)' }"
                        @click="openDialog('servico')"></button>
                </div>

                <!-- MODO CONTATO: campo removido. É sempre preenchido com "telefone"
                     automaticamente (ver ensureModoContatoTelefone). -->

                <!-- QUANTIDADE -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Quantidade:</label>
                    <input type="number" v-model="model.quantidade" placeholder="Quantidade"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': isEmptyField('quantidade') }" />
                </div>

                <!-- VALOR -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Valor:</label>
                    <input
                        disabled type="number" v-model="valor_total" placeholder="Valor"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]"
                        :class="{ 'input-required': !valor_total }" />
                </div>

                <!-- VALOR TOTAL APÓS DESCONTO -->
                <div v-if="model.desconto_percentual > 0" class="flex gap-2">
                    <label class="min-w-[7.5rem]">Valor Final:</label>
                    <input disabled type="number" :value="valorFinal" placeholder="Valor após desconto"
                        class="text-[10px] p-1 rounded-[5px] w-[18rem]" />
                </div>

                <!-- DESCONTO -->
                <div class="flex gap-2">
                    <label class="min-w-[7.5rem]">Desconto (%):</label>
                    <input type="number"
                           v-model="model.desconto_percentual"
                           placeholder="Desconto (%)"
                           min="0"
                           max="100"
                           step="0.01"
                           @input="updateCalculations"
                           class="text-[10px] p-1 rounded-[5px] w-[18rem]" />
                </div>

                <!-- Aviso de cliente potencial (o toast fica por trás do overlay) -->
                <div v-if="erroClientePotencial" class="dm-tag warn w-[25.5rem] whitespace-normal p-2">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    {{ erroClientePotencial }}
                </div>

                <!-- BOTÃO CRIAR -->
                <AppButton v-bind:visibility="true" :font_size="12" color="var(--icon)"
                    left_icon="fa-solid fa-pen-to-square" text="Criar" emitType="select" @select="save_config" />
            </div>
        </div>
    </div>

    <!-- DIALOGS / POPUPS -->
    <Dialog v-if="showDialog" @close="showDialog = false" @returnData="setSelectResult" :propsData="dialogProps"
        :pagination="true" />
    <Teleport to="body">
        <ClientPopUp v-if="showCreateLocal_PopUp" @close="showCreateLocal_PopUp = false" @returnData="setLocalInstalacao" />
    </Teleport>
    <Teleport to="body">
    <genericPopUp v-if="showConfigurations" title="Configurações" :model="{}" :checkBoxes="[
        {
            name: 'Manutenção TI Extintor',
            value: model?.local?.manuTiExtintor || 0,
        },
        {
            name: 'Manutenção TI Carretel',
            value: model?.local?.manuTiCarretel || 0,
        },
        {
            name: 'Manutenção TI RIA',
            value: model?.local?.manuTiRia || 0,
        },
        {
            name: 'Proforma',
            value: model?.local?.proforma,
        },
        {
            name: 'Purchase Order',
            value: model?.local?.purchaseOrder || 0,
        },
        {
            name: 'Encomenda Automática',
            value: model?.local?.encomendaAutomatica || 0,
        },
        {
            name: 'Faturação Agregada',
            value: model?.local?.faturacaoAgregada != '0',
        },
    ]" :setData="model?.localSetData || {}" :listBox="['5', '10', '15', '30']"
        :listChoice="model?.local?.faturacaoAgregada" @save="save_localConfig" @save_form="save_localForm"
        @close="showConfigurations = false" />
    </Teleport>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import Dialog from '@/components/dialog/dinamicDialog.vue';
import { toast } from "vue3-toastify";
import { id as loggedID } from '@/extraData'
import ClientPopUp from '@/components/popUps/clientCrudPopUp.vue';
import genericPopUp from '@/components/popUps/genericPopUp.vue';
import axios from "axios";
import { bloqueiaPorClientePotencial } from "@/utils/clientePotencial.js";

export default {
    components: {
        AppButton,
        Dialog,
        ClientPopUp,
        genericPopUp
    },
    props: {
        model_data: {
            type: Object,
            default: () => ({
                inicio: "",
                fim: "",
                tecnico: { nome: "", id: 0, valor: 0 },
                local: { nome: "", id: 0, purchaseOrder: false },
                tpNegocio: { nome: "", id: 0 },
                familia: { nome: "", id: 0 },
                servico: { nome: "", id: 0 },
                modoContato: { nome: "", id: 0 },
                quantidade: 1,
                valor: 0,
                desconto_percentual: 0,
                ordem_compra: "",
            })
        },
        isTecnico: {
            type: Boolean,
            default: false
        },
        hideTecnico: {
            type: Boolean,
            default: false
        },
        hideTime: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            baseURl: process.env.VUE_APP_URL_BASE,
            model: this.model_data,
            loggedID: loggedID,
            showDialog: false,
            currentType: null,
            showConfigurations: false,
            showCreateLocal_PopUp: false,
            erroClientePotencial: "",
            valor_total:0,
            dialogProps: {
                entity: ['localinstalacao', 'tpiva', 'tpmoeda'],
                sideBar: true,
                multi: false,
                queryParams: { 'equipamento': 'custom=1&tpmarca_id=1' },
                finalUrl: 'l=1',
            },

            /**
             * We store inicio/fim date/time fields separately so they don't overwrite each other.
             * The watchers apply the "first-time" logic to set FIM date/time.
             */
            inicioDate: "",
            inicioTime: "",
            fimDate: "",
            fimTime: "",

            hasSetDateOnce: false, // track if we've set inicioDate once
            hasSetTimeOnce: false, // track if we've set inicioTime once

            // Because user also requested "Only if hideTecnico is true" we do so in watchers
        };
    },
    computed: {
        valorFinal() {
            if (!this.valor_total || !this.model.quantidade) return 0;
            const baseAmount = this.valor_total * this.model.quantidade;
            const discountAmount = (baseAmount * (this.model.desconto_percentual || 0)) / 100;
            return parseFloat((baseAmount - discountAmount).toFixed(2));
        },
        requiresPurchaseOrder() {
            return !!this.model?.local?.purchaseOrder;
        },
        ordemCompraValida() {
            if (!this.requiresPurchaseOrder) return true;
            return !!(this.model?.ordem_compra && this.model.ordem_compra.toString().trim());
        }
    },
    mounted() {
        // If we come in with model_data that already has an inicio/fim, populate them
        // e.g. "2025-04-01T10:00"
        if (this.model.inicio) {
            const [d, t] = this.model.inicio.split("T");
            this.inicioDate = d || "";
            this.inicioTime = t || "";
        }
        if (this.model.fim) {
            const [d, t] = this.model.fim.split("T");
            this.fimDate = d || "";
            this.fimTime = t || "";
        }
        // Modo de contacto deixou de ser escolhido no formulário: usa sempre "telefone".
        this.ensureModoContatoTelefone();
    },
    watch: {
        // 1) Watch the 'inicioDate'. If user sets it for the first time, and fimDate is empty -> copy it.
        inicioDate(newVal, oldVal) {
            if (this.hideTime && newVal) {
                this.inicioTime = "09:00";
                this.fimTime = "09:00";
                if (!this.fimDate) this.fimDate = newVal;
                return;
            }

            // If hideTecnico == false, skip the logic
            if (!this.hideTecnico) return;

            // If user just set the date for the first time
            if (!oldVal && newVal) {
                // If fimDate is empty, set it to the same day
                if (!this.fimDate) {
                    this.fimDate = newVal;
                }
            }
        },

        // 2) Watch the 'inicioTime'. If user sets it for the first time, and fimTime is empty -> +2 hours
        inicioTime(newVal, oldVal) {
            // If hideTecnico == false, skip the logic
            if (!this.hideTecnico) return;

            // If we just set the time for the first time
            if (!oldVal && newVal) {
                // If fimTime is empty, set it = newVal + 2 hours
                if (!this.fimTime) {
                    // Parse HH:MM
                    const [h, m] = newVal.split(":").map(Number);
                    let dateObj = new Date(2025, 0, 1, h, m);
                    dateObj.setHours(dateObj.getHours() + 2);

                    // e.g. 02:30 => 04:30
                    const hh = String(dateObj.getHours()).padStart(2, "0");
                    const mm = String(dateObj.getMinutes()).padStart(2, "0");
                    this.fimTime = `${hh}:${mm}`;
                    console.log("fimTime set to ", this.fimTime);
                }
            }
        },

        // If new props come in, re-sync local model
        model_data: {
            handler(val) {
                this.model = val;
            },
            deep: true,
            immediate: true
        },

        // Watch for changes in quantidade or desconto_percentual to recalculate
        'model.quantidade': {
            handler() {
                this.updateCalculations();
            }
        },

        valor_total: {
            handler() {
                this.updateCalculations();
            }
        }
    },
    methods: {
        updateCalculations() {
            // Validate percentage input
            if (this.model.desconto_percentual !== undefined && this.model.desconto_percentual !== null) {
                const percentual = parseFloat(this.model.desconto_percentual) || 0;

                // Ensure percentage is within valid range
                if (percentual < 0) {
                    this.model.desconto_percentual = 0;
                } else if (percentual > 100) {
                    this.model.desconto_percentual = 100;
                }

                // Calculate discount amount from percentage
                const baseAmount = parseFloat((this.valor_total * this.model.quantidade).toFixed(2));
                const discountAmount = parseFloat(((baseAmount * this.model.desconto_percentual) / 100).toFixed(2));

                // Store the calculated discount amount for backend
                this.model.desconto = discountAmount;
            }
        },

        // On save, we build model.inicio = `${inicioDate}T${inicioTime}` (if they're both filled),
        // likewise for fim
        async save_config() {
            if (!this.validateForm()) {
                return;
            }
            // Cliente potencial: não deixar criar o serviço. A mensagem é mostrada
            // no próprio popup porque o toast fica por trás do overlay.
            this.erroClientePotencial = "";
            const local = await this.select(`${this.baseURl}/api/v1/localinstalacao/${this.model.local.id}/`);
            if (await bloqueiaPorClientePotencial({ cliente: local?.cliente }, { mostrarToast: false })) {
                this.erroClientePotencial =
                    "Não é possível criar o serviço: este é um cliente potencial. Transforme-o em cliente final ou habitual e adicione-o no Sage.";
                return;
            }
            // Garante o modo de contacto (telefone) caso o fetch do mounted ainda
            // não tenha terminado quando o utilizador submete.
            if (!this.model.modoContato || !this.model.modoContato.id) {
                await this.ensureModoContatoTelefone();
            }
            // Combine date/time into model.inicio/fim
            this.model.inicio = this.inicioDate && this.inicioTime
                ? `${this.inicioDate}T${this.inicioTime}`
                : "";
            this.model.fim = this.fimDate && this.fimTime
                ? `${this.fimDate}T${this.fimTime}`
                : "";

            // attach user ID
            this.model.utilizador_id = this.loggedID;
            this.$emit("save-servico", this.model);
        },
        close() {
            this.$emit("close");
        },
        isEmptyField(field) {
            
            return (!this.model[field] || this.model[field] <= 0);
        },
        validateForm() {
            // We want to be sure user has a valid date/time for both inicio and fim
            // If these are required. If partial is allowed, adapt accordingly

            const validations = [
                { condition: !this.inicioDate, field: "Data de Início" },
                { condition: !this.hideTime && !this.inicioTime, field: "Hora de Início" },
                { condition: !this.fimDate, field: "Data de Fim" },
                { condition: !this.hideTime && !this.fimTime, field: "Hora de Fim" },
                { condition: this.model.local.id === 0, field: "Local" },
                { condition: this.requiresPurchaseOrder && !this.ordemCompraValida, field: "Ordem de Compra" },
                { condition: this.model.tpNegocio.id === 0, field: "Tipo de Negócio" },
                { condition: this.model.familia.id === 0, field: "Família" },
                { condition: this.model.servico.id === 0, field: "Serviço" },
                { condition: this.model.quantidade <= 0, field: "Quantidade" },
                { condition: this.model.valor_total <= 0, field: "Valor Total" }
            ];

            const failedField = validations.find(validation => validation.condition);

            if (failedField) {
                toast(`Campo obrigatório: ${failedField.field}`, {
                    theme: "auto",
                    type: "warning",
                    position: "top-center",
                    autoClose: 2000,
                });
                return false;
            }
            return true;
        },
        isValidTime(time) {
            // 24-hour format HH:MM from 00:00 up to 23:59
            const timeRegex = /^([01]\d|2[0-3]):[0-5]\d$/;
            return timeRegex.test(time);
        },
        isValidDate(date) {
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            return dateRegex.test(date);
        },
        openDialog(type) {
            if (type === 'servico') {
                if (this.model.familia.id === 0) {
                    toast("Selecione o campo Familia !", {
                        theme: "auto",
                        type: "warning",
                        position: "top-center",
                        autoClose: 1000,
                    });
                    return;
                }
                if (this.model.local.id === 0) {
                    toast("Selecione o campo Local Instalação!", {
                        theme: "auto",
                        type: "warning",
                        position: "top-center",
                        autoClose: 1000,
                    });
                    return;
                }
                this.currentType = type;
                this.dialogProps.title = "serviços";
                this.dialogProps.entity[0] = `equipamento/filter/familia/${this.model.familia.id}/local/${this.model.local.id}`;
                this.showDialog = true;
            } else {
                this.currentType = type;
                this.dialogProps.title = type;
                this.dialogProps.entity = [type];
                // Restringir a seleção de locais ativos com cliente/subcliente ativos
                this.dialogProps.finalUrl = type === 'localinstalacao' ? 'only_active=true' : 'l=1';
                this.showDialog = true;
            }
        },
        async setSelectResult(data) {
            if (this.currentType === 'localinstalacao') {
                const selected = data.localinstalacao;
                let purchaseOrder = !!selected?.purchaseOrder;
                if (selected?.purchaseOrder === undefined && selected?.id) {
                    const full = await this.select(`${this.baseURl}/api/v1/localinstalacao/${selected.id}/`);
                    purchaseOrder = !!full?.purchaseOrder;
                }
                this.model.local = { ...selected, purchaseOrder };
                this.model.ordem_compra = '';
                this.erroClientePotencial = "";
                this.remove('servico');
            } else if (this.currentType === 'tpnegocio') {
                this.model.tpNegocio = data.tpnegocio;
            } else if (this.currentType === 'familia') {
                this.model.familia = data.familia;
                // Reset serviço
                this.remove('servico');
            } else if (this.currentType === 'servico') {
                this.model.servico = data.serviços;
                // HP: 2025-14-04
                // `${this.baseURl}/api/v1/itemprecario/?campo=equipamento_id&&valor=${this.model.servico.id}&&exact=true`
                const itemprecario = await this.select(
                    `${this.baseURl}/api/v1/itemprecariolocalequipamento/${this.model.local.id}/${this.model.servico.id}/`
                );
                if (itemprecario) {
                    this.model.valor = itemprecario.venda;
                }
                const itemprecariototal = await this.select(
                    `${this.baseURl}/api/v1/itemprecariolocalequipamento/extra/${this.model.local.id}/${this.model.servico.id}/`
                );
                if (itemprecariototal) {
                    this.valor_total = itemprecariototal.venda;
                }
            } else if (this.currentType === 'tecnico') {
                this.model.tecnico = {
                    nome: data.tecnico.user,
                    id: data.tecnico.id,
                    valor: data.tecnico.objetivoDiario,
                };
            } else if (this.currentType === 'tpmodocontato') {
                this.model.modoContato = data.tpmodocontato;
            }
        },
        remove(field) {
            this.model[field] = { nome: "", id: 0 };
        },
        async setLocalInstalacao(data) {
            const fetchedLocal = await this.select(`${this.baseURl}/api/v1/localinstalacao/${data.id}/`);
            this.model.local = { ...data, purchaseOrder: !!fetchedLocal?.purchaseOrder };
            this.model.ordem_compra = '';
            this.erroClientePotencial = "";
            if (fetchedLocal) {
                this.model.localSetData = {
                    cliente: {
                        id: fetchedLocal.cliente.id,
                        nome: fetchedLocal.cliente.cliente,
                    },
                    subcliente: fetchedLocal.subCliente,
                    zona: fetchedLocal.zona,
                    iva: fetchedLocal.iva,
                    tabelaPrecos: fetchedLocal.tabelaPrecos,
                };
            }
            this.remove('servico');
            this.showConfigurations = true;
        },
        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },
        // Preenche sempre o modo de contacto com "telefone" (campo removido do form)
        async ensureModoContatoTelefone() {
            try {
                const list = await this.select(
                    `${this.baseURl}/api/v1/tpmodocontato/s/nome/telefone/`
                );
                if (Array.isArray(list) && list.length) {
                    const tel =
                        list.find((m) => (m.nome || '').toLowerCase() === 'telefone') ||
                        list[0];
                    this.model.modoContato = { id: tel.id, nome: tel.nome };
                }
            } catch (error) {
                console.error('Erro ao definir modo de contacto (telefone):', error);
            }
        },
        async update(url, data) {
            try {
                const res = await axios.put(url, data);
                return res.data.data;
            } catch (error) {
                console.error("Erro ao atualizar:", error);
                throw error;
            }
        },
        async save_localConfig(data, listChoice, setData) {
            const localData = {
                cliente_id: setData.cliente.id || 0,
                subCliente_id: setData.subcliente.id || 0,
                tpZona_id: setData.zona.id || 0,
                tpIva_id: setData?.iva?.id || 0,
                tabelapreco_id: setData?.tabelaPrecos?.id || 0,
                manuTiExtintor: data[0].value || false,
                manuTiCarretel: data[1].value || false,
                manuTiRia: data[2].value || false,
                faturacaoAgregada: data.listChoice || '0',
                proforma: data[3].value || false,
                purchaseOrder: data[4].value || false,
                encomendaAutomatica: data[5].value || false,
                tempoArranque: 0,
                conetividade: "NENHUM",
            };
            try {
                const res = await this.update(
                    `${this.baseURl}/api/v1/localinstalacao/editar/${this.model.local.id}/`,
                    localData
                );
                if (res) {
                    toast.success("Local de instalação atualizado com sucesso", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1000,
                    });
                    this.showConfigurations = false;
                } else {
                    toast.error("Erro ao atualizar local de instalação", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1000,
                    });
                }
            } catch (error) {
                console.error('Error updating data:', error);
            }
        },
        async save_localForm(data) {
            // Implementation if needed
        },
    },
};
</script>

<style scoped>
input {
    background-color: var(--fundoForm);
    color: var(--text);
    border: 1px solid var(--glass-border);
}
</style>